import markPathAsSelected from '../helpers/markPathAsSelected'

export default function({ props, state }) {
  markPathAsSelected(state, props.path)
}



// WEBPACK FOOTER //
// ./src/modules/Node/actions/selectTreeNodes.js